import React from "react";
import styles from "./feature-grid.module.scss";
import { useTranslation } from "react-i18next";
import orderImg from "@/assets/orders.webp";
import ordersImg from "@/assets/documents.webp";
import stockImg from "@/assets/stock.webp";
import analoguesImg from "@/assets/analogues.webp";
export const FeatureGrid: React.FC = () => {
    const { t } = useTranslation();

    const features = [
        {
            title: "Ordering & cart",
            description: ["Create, save and reuse multiple baskets", "Upload parts lists and get priced baskets", "Download your priced orders", "Repeat orders in one click"],
            image: orderImg
        },
        {
            title: "Stock & availability",
            description: ["Real-time stock visibility", "Backorders and partial shipments", "Availability requests for quantity"],
            image: stockImg
        },
        {
            title: "Analogues & replacements",
            description: ["Find analogues and replacements instantly", "Compare prices and delivery times", "Make confident purchasing decisions faster"],
            image: analoguesImg
        },
        {
            title: "Documents & returns",
            description: ["Download invoices anytime", "Defective parts return management", "Clear order and document history"],
            image: ordersImg
        }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>
                {t("Everything you need to manage auto parts ordering")}
            </h2>
            <p className={styles.subtitle}>
                {t("All new workflows in one B2B system")}
            </p>

            <div className={styles.grid}>
                {features.map((item, index) => (
                    <div key={index} className={styles.card}>
                        <div className={styles.cardTitle}>{t(item.title)}</div>
                        <div className={styles.cardDescription}>
                            <ul className={styles.itemsList}>
                            {item.description.map((description, index) => (
                                <li>{description}</li>
                            ))}
                            </ul>
                        </div>
                        <div className={styles.cardImageContainer}>
                            <img src={item.image} alt="" className={styles.cardImage} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
